import type { ParsedUrlQuery } from 'querystring';
import { createFacetAttributeNames } from './createFacetAttributeNames';

export const createInitialRefinementList = (query: ParsedUrlQuery | null, locale?: string) => {
  const initialRefinementList: { [key: string]: string[] } = {};
  createFacetAttributeNames(locale).forEach((attribute) => {
    initialRefinementList[attribute] = [];
  });

  if (!query) {
    return initialRefinementList;
  }

  // For only the configuration attributes that has locale
  const refinementEntries = Object.entries(query)
    .filter(([queryKey]) => queryKey !== 'query')
    .map((refinementQuery) => refinementQuery);

  const refinementKeys = new Set(refinementEntries.map(([key]) => key.split('[')[0]));

  if (refinementEntries.length === 0) {
    return initialRefinementList;
  }

  refinementKeys.forEach((refinementKey) => {
    const refinementValue = refinementEntries
      .filter(([key]) => key.split('[')[0] === refinementKey)
      .filter(([_, value]) => value)
      .map(([_, value]) => value as string);
    initialRefinementList[refinementKey] = refinementValue;
  });

  return initialRefinementList;
};
